export const WEEK_DAYS = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
export const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
export const START_YEAR = 1990;
export const END_YEAR = 2050;
export const MONTH = 0;
export const YEAR = 0;
export const ABSENCE_CALENDAR = "Absence Calendar";
export const EMP_ABSENCE_CALENDAR = "Employee Absence Summary";
export const APP_TITLE = "Absence Manager";
export const NO_RECORDS = "No records found.";
export const REJECTED = "Rejected";
export const APPROVED = "Approved";
export const GENERIC_ERROR_MESSAGE = "Something went wrong ! Please try after sometime."